
/* ================================================
   DERMAPHARMA — COMPLETE JS FIX
   ================================================ */

(function() {
  'use strict';

  function init() {

    /* 1. Fix "LosMásVendidos" — broken heading with no spaces */
    document.querySelectorAll('h1, h2, h3, .section__heading').forEach(function(el) {
      if (el.textContent.includes('LosMásVendidos') || el.textContent.includes('LosMasVendidos')) {
        el.textContent = el.textContent
          .replace('LosMásVendidos', 'Los Más Vendidos')
          .replace('LosMasVendidos', 'Los Más Vendidos');
      }
    });

    /* 2. Fix all text nodes with broken spacing */
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while (node = walker.nextNode()) {
      var t = node.nodeValue;
      if (!t) continue;
      var fixed = t
        .replace(/LosMásVendidos/g, 'Los Más Vendidos')
        .replace(/LosMasVendidos/g, 'Los Más Vendidos');
      if (fixed !== t) node.nodeValue = fixed;
    }

    /* 3. Hide ALL placeholder "Título del producto" items */
    document.querySelectorAll('.grid-product, .card-product, [class*="product-item"]').forEach(function(card) {
      var title = card.querySelector('.grid-product__title, .card-product__title, [class*="product-title"]');
      if (title && (title.textContent.trim() === 'Título del producto' || title.textContent.trim() === 'Product title')) {
        card.style.display = 'none';
      }
    });

    /* 4. Add discount percentage badges to product cards */
    document.querySelectorAll('.grid-product, .card-product').forEach(function(card) {
      if (card.querySelector('.badge--sale, .badge--discount')) return;

      var priceEl = card.querySelector('.price--on-sale');
      if (!priceEl) return;

      var saleText = priceEl.querySelector('.price__sale, [class*="price-sale"]');
      var compareText = priceEl.querySelector('.price__compare, [class*="compare"], s, del');

      if (!saleText || !compareText) return;

      var saleNum = parseFloat(saleText.textContent.replace(/[^0-9.]/g, ''));
      var compareNum = parseFloat(compareText.textContent.replace(/[^0-9.]/g, ''));

      if (compareNum > saleNum && saleNum > 0) {
        var pct = Math.round((1 - saleNum / compareNum) * 100);
        if (pct >= 5) {
          var badge = document.createElement('div');
          badge.className = 'badge--sale';
          badge.style.cssText = 'position:absolute;top:8px;left:8px;background:#e03030;color:white;font-size:11px;font-weight:700;padding:3px 8px;border-radius:20px;z-index:10;';
          badge.textContent = '-' + pct + '%';
          var imageWrap = card.querySelector('.grid-product__image-wrap, .card-product__image, [class*="media"]');
          if (imageWrap) {
            imageWrap.style.position = 'relative';
            imageWrap.appendChild(badge);
          }
        }
      }
    });

    /* 5. Mobile: make sure header is not too tall */
    if (window.innerWidth <= 749) {
      var header = document.querySelector('.header, header, .site-header');
      if (header) {
        header.style.overflow = 'visible';
      }
    }

    /* 6. Fix announcement bar — make sure it scrolls smoothly on mobile */
    var marquees = document.querySelectorAll('.announcement__marquee, .marquee__track, [class*="ticker"]');
    marquees.forEach(function(m) {
      m.style.webkitOverflowScrolling = 'touch';
    });

    /* 7. Smooth scroll on all anchor links (exclude drawer/menu buttons) */
    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
      if (anchor.closest('[data-drawer-toggle]') || 
          anchor.closest('[data-drawer]') ||
          anchor.closest('.drawer') ||
          anchor.closest('button') ||
          anchor.hasAttribute('data-drawer-toggle') ||
          anchor.getAttribute('href') === '#' ||
          anchor.getAttribute('href') === '#!') return;
      anchor.addEventListener('click', function(e) {
        var href = this.getAttribute('href');
        if (href && href.length > 1) {
          var target = document.querySelector(href);
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      });
    });

    /* 8. Lazy load images that are offscreen (performance) */
    if ('IntersectionObserver' in window) {
      var imgObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var img = entry.target;
            if (img.dataset.src) {
              img.src = img.dataset.src;
              img.removeAttribute('data-src');
            }
            imgObs.unobserve(img);
          }
        });
      }, { rootMargin: '200px' });

      document.querySelectorAll('img[data-src]').forEach(function(img) {
        imgObs.observe(img);
      });
    }
  }

  /* Run on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-run after Shopify sections load */
  setTimeout(init, 800);
  setTimeout(init, 2000);

})();
